import { Input as OriginalInput } from 'antd';

export const Input: any = OriginalInput;
